import script from "./StudentDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDashboard.vue?vue&type=script&setup=true&lang=js"

import "./StudentDashboard.vue?vue&type=style&index=0&id=66aabbb2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66aabbb2"]])

export default __exports__